import React from 'react';
import { Button } from '@ver-uds/react';
import { useHistory } from 'react-router-dom';
import { useEnrollment } from '../../context/Enrollment/EnrollmentContext';
import { scrollToTop } from '../../utils/util';
import './EnrollmentStepperButtons.css';

export type EnrollmentStepperButtonsProps = {
  nextButtonType: 'submit' | 'button';
  noDivider?: boolean;
  showNextOnEdit?: boolean;
  onNext?: () => void;
  onBack?: () => void;
};

const EnrollmentStepperButtons = ({
  nextButtonType,
  noDivider,
  showNextOnEdit,
  onNext,
  onBack,
}: EnrollmentStepperButtonsProps): JSX.Element => {
  const { pageNumber, previousPage, nextPage, totalPages, activeEditPage } = useEnrollment();
  const history = useHistory();

  const handleClick = () => {
    if (onNext) {
      onNext();
    }
    if (nextButtonType === 'button') {
      nextPage();
    }
    scrollToTop();
  };

  const handleBackButtonClick = () => {
    if (pageNumber === 0) {
      // this approach supports both clients and company locations without having to know the account type
      const managePage = window.location.pathname.replace('/new', '');
      history.push(managePage);
    } else if (onBack) {
      onBack();
    } else {
      previousPage();
    }
    scrollToTop();
  };

  if (activeEditPage) {
    return (
      <>
        {!noDivider && <hr className="margin-top-3 margin-bottom-0" />}
        <Button
          type="button"
          variant="secondary"
          data-testid="back-button"
          onClick={previousPage}
          className="margin-right-1 margin-bottom-4"
        >
          Cancel
        </Button>
        <Button type={nextButtonType} data-testid="next-button" onClick={handleClick} className="margin-bottom-4">
          {showNextOnEdit ? 'Next' : 'Save'}
        </Button>
      </>
    );
  }

  const onLastPage = pageNumber === totalPages - 1;

  return (
    <>
      {!noDivider && <hr className="margin-top-5 margin-bottom-0" />}

      <Button
        type="button"
        variant="secondary"
        data-testid="back-button"
        onClick={handleBackButtonClick}
        className="margin-top-4"
      >
        Back
      </Button>

      {!onLastPage ? (
        <Button type={nextButtonType} data-testid="next-button" onClick={handleClick} className="margin-top-4">
          Next
        </Button>
      ) : (
        <Button type="submit" variant="submit" data-testid="submit-enrollment-buton" className="margin-top-4">
          Submit Enrollment
        </Button>
      )}
    </>
  );
};

export default EnrollmentStepperButtons;
